

export default async function (session, firebase) {
  // Can only be initiated on client side
  if (!process.client) {
    return
  }

  await import('firebase/messaging')

  if (firebase.messaging.isSupported()) {
    const messagingService = session.messaging()

    messagingService.usePublicVapidKey("BJw97hVcsXe9WyVHBsVNIk6_4-_rSbz80a4VE9IW9byVrWqej6n2vm35Vv8NLlaAa60xtm9d5nbEe_XsYE1KpTY")

    return messagingService
  }
}
